import { Calculator, FileText, HelpCircle, PhoneCall } from '@digital-twins/design-system/icons'
import { useTranslation } from 'react-i18next'

import { ROUTES } from '@/routes/routes'
import Link from '@/routing/Link'

import { CONTACT_SALES_URL } from './planConfig'

const ROW_CLASS =
  'flex h-10 w-fit items-center gap-2.5 whitespace-nowrap text-sm font-medium text-foreground underline-offset-2 hover:underline'
const ICON_CLASS = 'h-4 w-4 shrink-0 text-muted-foreground'

export interface BillingLinksProps {
  onOpenScenario: () => void
  onOpenCredits: () => void
}

/** The billing tab's links: one row height, an icon before every label, 2 x 2 or one row. */
export function BillingLinks(props: BillingLinksProps) {
  const { onOpenScenario, onOpenCredits } = props
  const { t } = useTranslation('app')

  return (
    // Sized by the column, not the screen: one per row on narrow phones, 2 x 2 while four do not
    // fit on one line (never 3 + 1), one row once they do.
    <div className="@container">
      <div
        data-testid="billing-links"
        className="grid w-fit grid-cols-1 gap-x-6 gap-y-1 px-5 @[24rem]:grid-cols-[auto_auto] @[40rem]:flex @[40rem]:flex-wrap"
      >
        <button type="button" onClick={onOpenScenario} className={ROW_CLASS} data-testid="credit-scenario-trigger">
          <Calculator className={ICON_CLASS} aria-hidden />
          {t('billing.estimateUsage')}
        </button>
        <button
          type="button"
          onClick={onOpenCredits}
          className={ROW_CLASS}
          data-testid="billing-how-credits-work-trigger"
        >
          <HelpCircle className={ICON_CLASS} aria-hidden />
          {t('billing.plans.howCreditsWork')}
        </button>
        <Link href={ROUTES.billingPlans} className={ROW_CLASS} data-testid="billing-link-view-plan">
          <FileText className={ICON_CLASS} aria-hidden />
          {t('billing.myPlan.viewPlan')}
        </Link>
        <a
          href={CONTACT_SALES_URL}
          target="_blank"
          rel="noreferrer"
          className={ROW_CLASS}
          data-testid="billing-link-talk-to-sales"
        >
          <PhoneCall className={ICON_CLASS} aria-hidden />
          {t('billing.myPlan.talkToSales')}
        </a>
      </div>
    </div>
  )
}
